import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { updateNameAndTitle, getUser, koalaAnalyticsActions } from 'actions';
import NameFormComponent from 'components/NameForm/NameFormComponent';
import { forms } from 'constants';
import appSelectors from 'selectors/app-selectors';
import { resetAppErrors } from 'actions/setters/updateAppErrors';
import { trimWhiteSpace } from 'utils/validation';

const validate = values => {
  const errors = {};
  if (!trimWhiteSpace(values.FirstName)) {
    errors.FirstName = 'Please enter your first name.';
  } else if (values.FirstName && values.FirstName.length > 50) {
    errors.FirstName = 'Please enter a first name less than 50 characters.';
  }
  if (!trimWhiteSpace(values.LastName)) {
    errors.LastName = 'Please enter your last name.';
  } else if (values.LastName && values.LastName.length > 50) {
    errors.LastName = 'Please enter a last name less than 50 characters.';
  }
  return errors;
};

const fetchData = dispatch => dispatch(getUser());

const NameFormContainer = reduxForm({
  form: forms.Name,
  validate,
})(NameFormComponent);

const mapStateToProps = state => ({
  initialValues: state.app.user.data,
  status: {
    isFetching: appSelectors.isPersonalDetailsFetching(state),
    ...state.app.appErrors,
  },
});

export const mapDispatchToProps = dispatch => ({
  submitHandler: values => dispatch(updateNameAndTitle(values)),
  fetchData: () => {
    fetchData(dispatch);
  },
  trackPageView: (subtype, pageSection) => {
    koalaAnalyticsActions.trackPageView(subtype, pageSection)(dispatch);
  },
  trackLinkClick: (subtype, pageSection, eventValue) => {
    koalaAnalyticsActions.trackLinkClick(
      subtype,
      pageSection,
      eventValue,
    )(dispatch);
  },
  resetAppErrors: () => {
    dispatch(resetAppErrors());
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps);

const NameFormContainerConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(NameFormContainer);

NameFormContainerConnected.fetchData = fetchData;

export default NameFormContainerConnected;
